<template>
  <button
    type="button"
    class="btn-method-payment"
    :class="{ active: active, disabled: disabled }"
    @click="handleClick"
  >
    <img
      class="img-fluid"
      :src="`data:image/jpg;base64,${methodPayment.picture}`"
      :alt="`metodo de pagamento ${methodPayment.name}`"
      :title="`metodo de pagamento ${methodPayment.name}`"
    />
    <p>{{ methodPayment.name }}</p>
  </button>
</template>

<script>
export default {
  props: {
    methodPayment: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["clicked-method-payment"],
  methods: {
    handleClick() {
      this.$emit("clicked-method-payment", this.methodPayment);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-method-payment {
  width: initial;
  padding: 5.5px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: var(--white);
  border: 1px solid var(--orange);
  border-radius: 30px;
  cursor: pointer;
  &.active {
    background: var(--orange);
    font-weight: 700;
    color: var(--white);
  }
  &.disabled {
    pointer-events: none;
    opacity: 0.6;
  }
  p {
    font-size: 12px;
    color: var(--black);
    font-family: "Font Regular";
    margin-bottom: 0;
  }
}
</style>
